type Props = {
  className?: string;
};

export function RifleSilhouette({ className }: Props) {
  return (
    <img
      className={className}
      src="/assets/art/m1908-silhouette.png?v=black"
      alt=""
      width={1920}
      height={780}
    />
  );
}
